export const getSecurityWaitTimeIconData = (
	waitSeconds: number | null,
	isOpen: boolean,
	hasOverrideMessage: boolean,
) => {
	const minutes = waitSeconds ? waitSeconds / 60 : null;

	if (hasOverrideMessage) return { number: 4, ariaLabel: 'Alert' };
	if (!isOpen || !minutes) return { number: 0, ariaLabel: 'Closed' };
	if (minutes < 15) return { number: 2, ariaLabel: 'Not Busy' };
	if (minutes < 30) return { number: 3, ariaLabel: 'Busy' };
	return { number: 4, ariaLabel: 'Very Busy' };
};
